(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-maison-rivoli"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      var slides = root.querySelectorAll('[data-mr-hero-slide]');
      var captions = root.querySelectorAll('[data-mr-hero-caption]');
      var dots = root.querySelectorAll('[data-mr-hero-dot]');
      if (!slides.length || !dots.length) return;

      var intervalMs = (parseFloat(root.getAttribute('data-autoplay')) || 5) * 1000;
      var current = 0;
      var timer = null;
      var captionTimer = null;
      // Must match the .mr-hero__caption transition duration: the outgoing
      // caption is given time to fully fade out before the incoming one
      // starts fading in, so the two texts are never visible at once.
      var CAPTION_SWAP_DELAY_MS = 400;

      function goTo(index) {
        if (index === current) return;
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        slides[index].classList.add('is-active');
        slides[index].setAttribute('aria-hidden', 'false');

        if (captions[current]) captions[current].classList.remove('is-active');
        if (captionTimer) clearTimeout(captionTimer);
        captionTimer = setTimeout(function () {
          if (captions[index]) captions[index].classList.add('is-active');
          captionTimer = null;
        }, CAPTION_SWAP_DELAY_MS);

        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-current', 'false');
        dots[index].classList.add('is-active');
        dots[index].setAttribute('aria-current', 'true');

        current = index;
      }

      function next() {
        goTo((current + 1) % slides.length);
      }

      function start() {
        if (timer) clearInterval(timer);
        timer = setInterval(next, intervalMs);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
          start();
        });
      });

      start();
    }

    document.querySelectorAll('[data-mr-hero]').forEach(initHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-maison-rivoli"]) return;
  try {
    
  (function () {
    var BATCH_SIZE = 6;

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-avis-more-btn]');
      if (!btn) return;

      var wrapper = btn.closest('.mr-pdp-reviews');
      if (!wrapper) return;

      var pendingCards = wrapper.querySelectorAll('[data-avis-extra].mr-avis-card--pending');
      var toReveal = Array.prototype.slice.call(pendingCards, 0, BATCH_SIZE);

      toReveal.forEach(function (card) {
        card.classList.remove('mr-avis-card--pending');
        card.style.opacity = '0';
        // Force layout so the transition below animates from this
        // starting opacity instead of jumping straight to visible.
        void card.offsetWidth;
        card.style.transition = 'opacity 0.4s ease';
        card.style.opacity = '1';
      });

      if (wrapper.querySelectorAll('[data-avis-extra].mr-avis-card--pending').length === 0) {
        btn.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
